import React, { useContext, useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';

import ScreenTextContext from '../../contexts/ScreenTextContext';
import { SelectedCategories } from '../SelectedCategories';
import { TaskMarkers, TeamCard } from '../';
import { Button } from '../';
import { useTheme } from '@material-ui/core';
import { MODES, MODE_SPECS } from '../../utils/constants';
import { ModeLogo } from '../ModeLogo';
import { TaskResultCount } from '../TaskResultCount';

export const WrapUp = ({game, points}) => {

  const { screenText } = useContext(ScreenTextContext);  
  const theme = useTheme();
  const audioRef = useRef();

  useEffect(() => {
    if (!audioRef || !audioRef.current) return;

    audioRef.current.play();
    
    const colors = ['#FFD754', '#ffffff', theme.palette.navyLight1];

    const confettiProps = {
      particleCount: 150,
      spread: 75,
      startVelocity: 90,
      colors: colors,
    }

    // left side
    confetti({
      ...confettiProps,
      angle: 70,
      origin: { x: 0, y: 1.1 },
    });

    // right side
    confetti({
      ...confettiProps,
      angle: 110,
      origin: { x: 1, y: 1.1},
    });

  }, [theme.palette])

  if (!screenText || !screenText.global || !screenText.wrapUp ) {
    return ''; // Should return error? Loading?
  }

  const { tieTitle, winTitle, tieDescriptionPositive, tieDescriptionNeutral, tieDescriptionNegative, winDescription } = screenText.wrapUp;

  const isTie = points[0] === points[1];
  const winner = points.indexOf(Math.max(...points));


  const getDescription = () => {
    // If either team one, return the win description    
    if (points[0] !== points[1]) {
      return winDescription;
    } 
    // If it is a tie, figure out how well they did overall.

    const totalPossible = MODE_SPECS[game.mode].reduce((total, round) => {
      let { taskCount } = round;

      if(!taskCount) {
        taskCount = Math.floor(game.lecture.length / 2);
      }

      return total += taskCount * round.taskPointValue;
    }, 0);

    const percent = points[0] / totalPossible;

    if (percent >= .8 ) {
      return tieDescriptionPositive;
    } else if (percent >= .51) {
      return tieDescriptionNeutral;
    } else {
      return tieDescriptionNegative;
    }
  }


  return (
    <div className="wrap-up">

        <div aria-hidden="true">
          <audio ref={audioRef} src={`${process.env.PUBLIC_URL}/assets/audio/applause.wav`} />
        </div>

      {/* <ChevronTitle title={screenText.wrapUp.title} preTitle={screenText.global.modes[game.mode].fullTitle} /> */}

      <div className="round-intro__logo">
        <ModeLogo mode={game.mode} />
        <div className="dotted-line"></div>
      </div> 
      
      <div className="wrap-up__container">

        <div className="wrap-up__center-col">
          
          {/* Title */}
          <h2 className="wrap-up__result-title">
            { isTie ? tieTitle : winTitle }
          </h2>
          
          {/* Text */}
          <div className="wrap-up__description">

            {getDescription()}
            
          </div>
          
        </div>

        {game.teams.map((team, teamIndex) => {

          const active = isTie || winner === teamIndex;
          
          return (
            <div 
              key={teamIndex} 
              className={`wrap-up__team-col wrap-up__team-col--${teamIndex} ${active ? 'wrap-up__team-col--winner' : ''}`} 
              style={{position: 'relative'}}
            >

              <TeamCard team={team} active={active} sparkle={active}  />

              {/* Points tally */}
              <div className="wrap-up__points-number">{points[teamIndex]}</div>
              <div className="wrap-up__points">{screenText.wrapUp.points}</div>

            {/* Total right and wrong */}
              <div className="wrap-up__task-markers-wrapper">
                {game.scores[teamIndex].map((round, roundIndex) => (
                  game.mode === MODES.LECTURE ? 
                    // UI assumes only one round for lecture mode
                    // Coded to be more flexible, just in case
                    <TaskResultCount
                      key={roundIndex}
                      roundScore={round}
                      // currentRoundIndex={roundIndex}
                    />
                  :
                    <TaskMarkers round={round} key={roundIndex} roundIndex={roundIndex} />
                ))}
              </div>

            </div>
          )
        })}
      
      </div>

      <SelectedCategories categories={game.categories} />

      <Button variant="primary" mods={["wide"]} onClick={() => { window.location.reload() }}>{screenText.wrapUp.restart}</Button>

    </div>
)

}